import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledExtensionBanner = styled.div<{ isOpen?: boolean }>`
    overflow: hidden;
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 1070;
    width: 325px;
    height: 368px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0px 4px 11px 0px rgba(141, 141, 141, 0.25);
    background-color: ${colorsPalettes.carbon[0]};
    transition: transform 0.3s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? "translateX(0)" : "translateX(120%)")};
`;

export const StyledExtensionBannerImageBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 192px;
    background:
        radial-gradient(102.73% 320.75% at 100.49% 1.66%, #ffe2eb 0%, #e6edff 52.98%),
        linear-gradient(0deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5));
`;

export const StyledExtensionBannerImage = styled.img`
    width: 177px;
    height: 167px;
    margin-left: -8px;
    margin-top: 1px;
`;

export const StyledExtensionBannerCloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 0;
    margin-right: 8px;
`;

export const StyledExtensionBannerTextBlock = styled.div`
    padding: 24px;
`;

export const StyledExtensionBannerTitle = styled.p`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])};
    line-height: 20px;
    font-weight: 700;
    margin: 0 0 8px;
`;

export const StyledExtensionBannerDescription = styled.p`
    ${mixins.setFontVariant("report", colorsPalettes.carbon[500])};
    line-height: 20px;
    margin: 0 0 24px;
`;

export const StyledExtensionBannerButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledExtensionBannerOverlay = styled.div<{ isOpen?: boolean }>`
    transition: opacity 0.3s ease-in-out;
    background-color: rgba(9, 37, 64, 0.21);
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 1060;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
`;
